(function($){
    $(document).ready(function(){
        if($('#commentform').length > 0){
            $('#commentform [type="submit"] .qodef-m-text').html('Dodaj opinię');
        }
    });
    if($('.woocommerce-product-gallery.qodef-position--below').length > 0){
        setInterval(function(){
            $('.woocommerce-product-gallery.qodef-position--below').css('display', 'block');
        }, 100)
        setInterval(function(){
            $('.dialog-lightbox-widget').remove();
        }, 1)
    }
    $('body').on('click', '.qodef-woo-thumbnails-wrapper a', function(e){
        e.preventDefault();
        $('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image a').remove();
        var newa = $(this).clone();
        $('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image').prepend(newa);
        var zoomimg = $(this).attr('href');
        var width = $('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image > img').width();
        var height = $('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image > img').height();
        $('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image > img').attr('src', zoomimg);
        setTimeout(function(){
            $('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image > img').css('width', width);
            $('.woocommerce-product-gallery__wrapper > .woocommerce-product-gallery__image > img').css('height', height);
        }, 300)
    })
    $('.woocommerce-product-gallery__image').each(function(){
        $(this).find('img').attr('src', $(this).find('img').attr('src').replace('-250x380', ''));
    })
    if($('#qodef-page-inner > .elementor-element-0db906e').length > 0){
        $('.elementor-element-0db906e').wrapAll('<div class="elementor elementor-352270" />')
    }

})(jQuery)